import { render, staticRenderFns } from "./TabChangePassword.vue?vue&type=template&id=9d5afa34&scoped=true"
import script from "./TabChangePassword.vue?vue&type=script&lang=ts"
export * from "./TabChangePassword.vue?vue&type=script&lang=ts"
import style0 from "./TabChangePassword.vue?vue&type=style&index=0&id=9d5afa34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5afa34",
  null
  
)

export default component.exports